<template>
    <div class="wrapper  ">
        <div class="u_header">
            <img src="../../assets/img/logo.png" alt="" class="img" />
       
            <el-dropdown @command="setDialogInfo" size="small">
                <el-avatar class="avatar"
                  src="https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif?imageView2/1/w/80/h/80"
                ></el-avatar>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
     
        </div> 
        
        <div class="u_header1">
            <v-sidebar ></v-sidebar>
            <div class="content-box">
                <transition name="fade-transform" mode="out-in">
                    <router-view     > </router-view>
                </transition>
            </div>
        </div>
    </div>
</template>
<script>
import vSidebar from './Sidebar.vue';

export default {
    data() {
        return {
        
           
        };
    },
    components: {
        vSidebar
    },
   
   
    created() {
        
        // if (window.history && window.history.pushState) {
        //     history.pushState(null, null, document.URL);
        //     window.addEventListener('popstate', this.goBack, false);
        // }
    },
    destroyed() {
        // window.removeEventListener('popstate', this.goBack, false);
        // if (localStorage.getItem('user_type') == 'user') {
        //     this.$router.replace({ path: '/detail' });
        // } else {
        //     this.$router.replace({ path: '/dashboard' });
        // }
    },
    methods: {
       
     
        setDialogInfo(comItem) {
    //   switch (comItem) {
    //     case "info":
    //       this.showInfoList();
    //       break;
    //     case "logout":
          this.logout();
    //       break;
    //   }
    },
    logout() {
            this.$confirm('确定退出登录吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    //点击确定的操作(调用接口)
                    localStorage.removeItem('user');
                    localStorage.removeItem('auth_info');
                    localStorage.removeItem('token');
                    localStorage.removeItem('pdaToken');
                    localStorage.removeItem('area');
                    localStorage.removeItem('items');
                    localStorage.removeItem('index');
                    localStorage.removeItem('newItem');
                    localStorage.removeItem('role_permission_info');

                    this.$router.replace('/login');
                })
                .catch(() => {});
        },
        goBack() {}
    }
};
</script>
<style lang="scss" scoped>
.el-dropdown-menu {
  background-color: #2b2b2b;  // 背景颜色
  border:none; 
}

    .el-dropdown-menu__item {
        color: rgba(235, 235, 235, 1);
    }
    .el-dropdown-menu__item:not(.is-disabled):hover {
        background: none !important;
        color: rgba(235, 235, 235, 1);
        
    }
.el-dropdown{
    display: flex;
    align-items: center;
}
.avatar{
    width: 25px;
    height: 25px;
    margin-right: 7px;
}
 @media (min-width: 1920px) {
    .layout{
      margin-left: auto;
    margin-right: auto;
    max-width:1920px;
    }
  
   
}

.wrapper{
  
   
}
.u_header1 {
    display: flex;
    // padding: 35px 0 0 0;
}
.u_header {
    width: 100%;
    background: rgba(64, 64, 64, 1);
    height: 34px;
    display: flex;
    align-items: center;
    margin-bottom: 1px;
    justify-content: space-between;
   
    .img {
        width: 61.64px;
        height: 10.44px;
        margin-left: 7px;
    }
}
// .left {
//     position: absolute;
//     width: 26px;
//     height: 26px;
//     left: 187px;

//     top: 76px;
//     background: #effafe;
//     border-radius: 50%;
//     z-index: 99;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     -webkit-transition: left 0.3s ease-in-out;
//     transition: left 0.3s ease-in-out;
//     img {
//         width: 24px;
//         height: 24px;
//     }
// }
// .left1 {
//     left: 65px !important;
//     -webkit-transition: right 0.3s ease-in-out;
//     transition: right 0.3s ease-in-out;
// }
// .left-collapse {
//     transform: rotateY(180deg);
// }
</style>
